import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-343986cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = { class: "faq" }
const _hoisted_3 = { class: "faq-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, " Nutze FAQ-Paare um häufige Fragen automatisch zu beantworten. Füge mehrere Ausdrücke (in der Regel Beispiel Fragen hinzu) und ein oder mehr Textnachrichten hinzu. Anschließend kann der Chatbot diese Fragen automatisch beantworten. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("kbd", null, "Enter", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("kbd", null, "Shift", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("kbd", null, "Enter", -1))
const _hoisted_8 = { class: "examples-table" }
const _hoisted_9 = { class: "messages-wrapper" }
const _hoisted_10 = { class: "messages" }
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = { class: "buttons" }
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Erweiterte Einstellungen", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "keyboard_arrow_down", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 0,
  class: "advanced-body"
}
const _hoisted_19 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_input_field = _resolveComponent("md-input-field")!
  const _component_md_hint = _resolveComponent("md-hint")!
  const _component_md_alert = _resolveComponent("md-alert")!
  const _component_transition_fade = _resolveComponent("transition-fade")!
  const _component_md_table_column = _resolveComponent("md-table-column")!
  const _component_md_table = _resolveComponent("md-table")!
  const _component_empty_hint = _resolveComponent("empty-hint")!
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_checkbox = _resolveComponent("md-checkbox")!
  const _component_md_card = _resolveComponent("md-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_md_input_field, {
          variant: "outlined",
          modelValue: _ctx.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
          label: "Name des FAQ-Paars"
        }, null, 8, ["modelValue"]),
        _hoisted_4,
        _createVNode(_component_md_input_field, {
          variant: "outlined",
          modelValue: _ctx.example,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.example) = $event)),
          label: "Neuen Ausdruck hinzufügen",
          error: false,
          onKeydown: _ctx.exampleKeyDown
        }, null, 8, ["modelValue", "onKeydown"]),
        _createVNode(_component_md_hint, { icon: "info" }, {
          default: _withCtx(() => [
            _createTextVNode(" Drücke "),
            _hoisted_5,
            _createTextVNode(" um einen Ausdruck hinzuzufügen. Oder drücke "),
            _hoisted_6,
            _createTextVNode(" + "),
            _hoisted_7,
            _createTextVNode(" um diesen Ausdruck hinzuzufügen und eine automatische Übersetzung für alle Sprachen zu erzeugen. ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_transition_fade, null, {
          default: _withCtx(() => [
            (_ctx.showTranslationDelayAlert)
              ? (_openBlock(), _createBlock(_component_md_alert, {
                  key: 0,
                  icon: "schedule"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Übersetzte Ausdrücke stehen in der Regel erst einige Sekunden nach dem Hinzufügen zur Verfügung. Eventuell werden diese daher noch nicht in allen Sprachen angezeigt. ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        ((_ctx.rows && _ctx.rows.length > 0) || _ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_md_table, {
              key: 0,
              rows: _ctx.rows,
              onButtonClick: _ctx.handleTableButtonClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_md_table_column, {
                  title: "Phrase",
                  display: "text"
                }),
                _createVNode(_component_md_table_column, {
                  title: "Score",
                  display: "score",
                  type: "badge",
                  numeric: true
                }),
                _createVNode(_component_md_table_column, {
                  title: "",
                  display: "delete",
                  type: "button"
                })
              ]),
              _: 1
            }, 8, ["rows", "onButtonClick"]))
          : (_openBlock(), _createBlock(_component_empty_hint, {
              key: 1,
              variant: "inline",
              title: 'Keine Ausdrücke für ' + _ctx.languageName + ' hinzugefügt',
              description: "Gebe oben im Eingabefeld einen Ausdruck ein und drücke anschließend Enter, um diesen hinzuzufügen."
            }, null, 8, ["title"])),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (msg, key) => {
                return (_openBlock(), _createElementBlock("li", { key: key }, [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": ($event: any) => ((msg[_ctx.language]) = $event),
                    placeholder: "Text Nachricht hier eingeben..."
                  }, null, 8, _hoisted_11), [
                    [_vModelText, msg[_ctx.language]]
                  ]),
                  _createVNode(_component_md_button, {
                    variant: "icon",
                    grey: "",
                    icon: "delete_forever",
                    onClick: ($event: any) => (_ctx.messages.splice(key, 1))
                  }, null, 8, ["onClick"])
                ]))
              }), 128))
            ]),
            _createVNode(_component_md_button, {
              variant: "text",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.messages.push({})))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Nachricht hinzufügen")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons, (btn, key) => {
                return (_openBlock(), _createElementBlock("li", { key: key }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => ((btn.label[_ctx.language]) = $event),
                    placeholder: "Button Label"
                  }, null, 8, _hoisted_13), [
                    [_vModelText, btn.label[_ctx.language]]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => ((btn.value) = $event),
                    placeholder: "URL (mit https://)"
                  }, null, 8, _hoisted_14), [
                    [_vModelText, btn.value]
                  ]),
                  _createVNode(_component_md_button, {
                    variant: "icon",
                    grey: "",
                    icon: "delete_forever",
                    onClick: ($event: any) => (_ctx.buttons.splice(key, 1))
                  }, null, 8, ["onClick"])
                ]))
              }), 128))
            ]),
            _createVNode(_component_md_button, {
              variant: "text",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.buttons.push({ label: {}, value: '' })))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Button hinzufügen")
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_md_card, {
          variant: "outlined",
          class: "advanced"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["header", { active: _ctx.advancedSettingsOpen }]),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.advancedSettingsOpen = !_ctx.advancedSettingsOpen))
            }, _hoisted_17, 2),
            (_ctx.advancedSettingsOpen)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_component_md_checkbox, {
                    modelValue: _ctx.intelligentEnquireActive,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.intelligentEnquireActive) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Intelligentes Nachfragen für dieses FAQ-Paar aktivieren. ")
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_md_input_field, {
                    variant: "outlined",
                    modelValue: _ctx.intelligentEnquireQuestion[_ctx.language],
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.intelligentEnquireQuestion[_ctx.language]) = $event)),
                    label: "Nachfrage für dieses FAQ-Paar",
                    disabled: !_ctx.intelligentEnquireActive
                  }, null, 8, ["modelValue", "disabled"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_md_button, { variant: "text" }, {
            default: _withCtx(() => [
              _createTextVNode("Abbrechen")
            ]),
            _: 1
          }),
          _createVNode(_component_md_button, {
            variant: "filled",
            onClick: _ctx.saveChanges
          }, {
            default: _withCtx(() => [
              _createTextVNode("FAQ-Paar speichern")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ]))
}